import { createApp } from 'vue'
import '@/assets/styles/index.less'
import App from './App.vue'

import registerDirectives from './directives'
import '@unocss/reset/tailwind.css'
import 'virtual:svg-icons-register'
import 'virtual:uno.css'
import 'driver.js/dist/driver.css'
// import 'uno.css'
// import 'virtual:unocss-devtools'

import plugins from '@/plugins'

const app = createApp(App)

registerDirectives(app)

app.use(plugins).mount('#app')
